import { render, staticRenderFns } from "./VideoList.vue?vue&type=template&id=422bbfa8&scoped=true&lang=pug&"
import script from "./VideoList.vue?vue&type=script&lang=ts&"
export * from "./VideoList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422bbfa8",
  null
  
)

export default component.exports